import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "use-intl";
import { Button } from "../Button";
export function ViewItemsOnProfileButton(t0) {
  const $ = _c(12);
  const {
    itemIds,
    walletDestinationAddress
  } = t0;
  const t = useTranslations("wallet.ViewItemsOnProfileButton");
  const profilePath = walletDestinationAddress ? `/profile/${walletDestinationAddress}` : "/profile";
  let t1;
  if ($[0] !== itemIds) {
    t1 = itemIds.join(",");
    $[0] = itemIds;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      sortBy: "received_date",
      highlight: t1,
      sortDirection: "desc"
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== profilePath || $[5] !== t2) {
    t3 = {
      pathname: profilePath,
      query: t2
    };
    $[4] = profilePath;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("viewOnProfile");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Button href={t3} variant="secondary">{t4}</Button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}